import { createFileRoute } from '@tanstack/react-router'

import { ListPageHeader } from '@/components/common/ListPageHeader'
import { PageEditor } from '@/components/retail/cms/page-editor'
import { useAuth } from '@/hooks/use-auth'
import { useShopPage } from '@/hooks/use-shop-pages-query'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/retail/pages/$pageId',
)({
    component: EditPagePage,
})

function EditPagePage() {
    const { pageId } = Route.useParams()
    const { hasPermission } = useAuth()
    const query = useShopPage(pageId)
    if (query.isLoading)
        return (
            <p className="page-pad text-muted-foreground">
                {m.common_loading()}
            </p>
        )
    const page = query.data?.data
    if (!page)
        return (
            <p className="page-pad text-destructive" role="alert">
                {m.cmsPage_not_found()}
            </p>
        )
    return (
        <div className="space-y-4 page-pad">
            <ListPageHeader title={page.fields.title} />
            {/* key: form nạp lại sau mỗi lần lưu (version mới). */}
            <PageEditor
                key={`${page.id}:${page.version}`}
                page={page}
                kind={page.kind}
                canWrite={hasPermission('shop_content.write')}
            />
        </div>
    )
}
